<template>
  <div class="esp_text_area_edit" :style="{backgroundColor: bgColor, padding: padding, textAlign:textAlign}">
    <el-popover width="500"
                placement="right"
                popper-class="esp_area_edit_popover"
                ref="popoverRef"
                @hide="hidePopover()"
                :trigger="trigger">
      <div slot="reference" class="esp_area_reference" v-if="showAll">
        {{ value }}
        <i class="el-icon-edit"></i>
      </div>
      <div slot="reference" class="esp_area_reference" v-else>
        {{ value.slice(0, maxLength) }}...
        <i class="el-icon-edit"></i>
      </div>

      <div class="esp_edit_popover_content">
        <textarea v-model="valueTemp"
                  :maxlength="inputMaxLength"
                  @input="calcLength()"
                  class="esp_textarea">
        </textarea>
        <div class="esp_edit_popover_btn">
          <div>{{ actual }}/{{ inputMaxLength }}</div>
          <el-button type="text" @click="confirm()">确定</el-button>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "EspTextAreaEdit",
  data() {
    return {
      valueTemp: "",
      actual: 0
    }
  },
  props: {
    value: {            // 文本内容
      type: String,
      default: ""
    },
    maxLength: {        // 文本最大显示长度 (没有的话就全部显示)
      type: Number,
      default: 0
    },
    inputMaxLength: {
      type: Number,
      default: 1000
    },
    trigger: {          // 触发方式 (click、focus、hover、manual)
      type: String,
      default: "hover"
    },
    bgColor: {          // 背景色
      type: String,
      default: "transparent"
    },
    padding: {          // 内边距
      type: String,
      default: "0px"
    },
    textAlign: {        // 内容对其方式
      type: String,
      default: "left"
    }
  },
  methods: {
    // 点击确定按钮时触发
    confirm: function () {
      this.$refs.popoverRef.doClose();
    },

    // 弹框关闭时触发
    hidePopover: function () {
      this.$emit("doConfirm", this.valueTemp)
    },

    // 计算已输入的字符长度
    calcLength: function () {
      this.actual = this.valueTemp ? this.valueTemp.length : 0;
    }
  },
  computed: {
    // 计算显示类型
    showAll: function () {
      if (!this.value || this.maxLength <= 0 || this.value.length <= this.maxLength) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        this.valueTemp = newVal;
        this.calcLength();
      },
      immediate: true
    }
  }
}
</script>

<style lang="less">
.esp_text_area_edit {
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  .el-icon-edit {
    color: #409EFF;
    font-size: 14px;
  }

  .esp_area_reference {
    cursor: pointer;
    height: 100%;
  }
}

.esp_area_edit_popover {
  height: 80%;
  min-height: 200px;

  .esp_edit_popover_content {
    height: 100%;
  }

  .esp_edit_popover_btn {
    text-align: right;
    position: relative;

    .el-button {
      font-size: 15px;
      font-weight: bold;
      position: relative;
      top: -3px;
    }

    & > div {
      position: absolute;
      left: 0px;
      top: 5px;
      font-size: 12px;
    }
  }

  .esp_textarea {
    width: 100%;
    height: calc(100% - 28px);
    resize: none;
    outline: none;
    border-radius: 0px;
    padding: 2px 5px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    font-family: "PingFangSC-Regular", "Microsoft YaHei", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/form/EspTextAreaEdit.vue